import createCachedSelector from 're-reselect';
import { get } from 'lodash-es';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectFulfillments = (state) => get(state, 'fulfillments', emptyObject);
export const selectFulfillmentById = (state, props) => get(selectFulfillments(state, props), props.fulfillmentId);

export const selectFulfillmentsByIds = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds),
  (fulfillments, fulfillmentIdsJSON) => {
    const fulfillmentIds = JSON.parse(fulfillmentIdsJSON);

    if (fulfillmentIds.length === 0) {
      return emptyArray;
    }

    return fulfillmentIds.map((fulfillmentId) => fulfillments[fulfillmentId]);
  },
)((_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds));

export const selectFulfillmentsByFulfillmentPlanId = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentPlanId }) => fulfillmentPlanId,
  (fulfillments, fulfillmentPlanId) => {
    if (!fulfillmentPlanId) {
      return emptyArray;
    }

    const fulfillmentsForFulfillmentPlan = Object.values(fulfillments).filter(
      (fulfillment) => fulfillment.fulfillmentPlanId === fulfillmentPlanId,
    );

    // reselect docs recommend returning a static empty array if there are no results
    return fulfillmentsForFulfillmentPlan.length ? fulfillmentsForFulfillmentPlan : emptyArray;
  },
)((_, { fulfillmentPlanId }) => fulfillmentPlanId || '');

export const selectFulfillmentsByFulfillmentPlanIds = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentPlanIds }) => JSON.stringify(fulfillmentPlanIds),
  (fulfillments, fulfillmentPlanIdsJSON) => {
    const fulfillmentPlanIds = JSON.parse(fulfillmentPlanIdsJSON);
    if (!fulfillmentPlanIds.length) {
      return emptyArray;
    }

    return Object.values(fulfillments).filter((fulfillment) => fulfillmentPlanIds.includes(fulfillment.fulfillmentPlanId));
  },
)((_, { fulfillmentPlanIds }) => JSON.stringify(fulfillmentPlanIds));

export const selectFPIdsByFulfillmentIds = createCachedSelector(
  (state, props) => (props.fulfillmentIds ? selectFulfillmentsByIds(state, props) : emptyArray),
  (_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds ?? null),
  (fulfillments, fulfillmentIdsJSON) => {
    const fulfillmentIds = JSON.parse(fulfillmentIdsJSON);
    if (!fulfillmentIds) {
      return emptyArray;
    }
    const fpidSet = new Set();
    for (const fulfillment of fulfillments) {
      const fpid = fulfillment?.fulfillmentPlanId;
      if (fpid) {
        fpidSet.add(fpid);
      }
    }
    return fpidSet.size === 0 ? emptyArray : Array.from(fpidSet);
  },
)((_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds ?? null));
